import React from 'react';
import {
  Row,
  Col,
  Typography,
  Table,
  Card,
  Tag,
  Statistic,
} from 'antd'
// import {
//   SearchOutlined
// } from '@ant-design/icons';

const columns = [
  {
    title: 'รุ่น',
    dataIndex: 'name',
    key: 'name',
  },
  {
    title: 'ประเภท',
    dataIndex: 'category',
    key: 'category',
    render: (text, _) => text?.name ?? "_",
    //   filters: categories.map(f => ({ text: f.name, value: f.name })),
    //   onFilter: (value, record) => record?.category?.name.indexOf(value) === 0,
    //   sorter: (a, b) => a?.category?.name.localeCompare(b?.category?.name),
  },
  {
    title: 'แบรนด์',
    dataIndex: 'brand',
    key: 'brand',
    render: (text, _) => text?.name ?? "_",
    //   render: (_, record) => record?.brand?.name ?? "_",
    //   filters: brands.map(f => ({ text: f.name, value: f.name })),
    //   onFilter: (value, record) => record?.brand?.name.indexOf(value) === 0,
    //   sorter: (a, b) => a?.brand?.name.localeCompare(b?.brand?.name),
  },
  {
    title: 'สี',
    dataIndex: 'color',
    key: 'color',
  },
  {
    title: 'ราคาขายต่ำสุด',
    dataIndex: 'min_price',
    key: 'min_price',
    render: text => <Statistic value={text} precision={2} valueStyle={{ fontSize: 14 }} />
  },
  {
    title: 'ราคาปกติ',
    dataIndex: 'price',
    key: 'price',
    render: text => <Statistic value={text} precision={2} valueStyle={{ fontSize: 14 }} />
  },
  {
    title: 'ราคาขาย',
    dataIndex: 'selling_price',
    key: 'selling_price',
    render: text => <Statistic value={text} precision={2} valueStyle={{ fontSize: 14 }} />
  },
  {
    title: 'มูลค่าต่อหน่วย',
    dataIndex: 'average_price',
    key: 'average_price',
    render: text => <Statistic value={text} precision={2} valueStyle={{ fontSize: 14 }} />
  },
  {
    title: 'จำนวนคงเหลือ',
    dataIndex: 'stock',
    key: 'stock',
  },
  {
    title: 'สถานะ',
    dataIndex: 'is_active',
    key: 'is_active',
    render: (_, record) => record.is_active ? <Tag color="green">ขาย</Tag> : <Tag color="red">ยกเลิก</Tag>
  },
]

function DashboardInventory({ products, productQuantity, productPrice }) {

  // console.log(productPrice);
  return (
    <Card
      bordered={false}
      bodyStyle={{
        border: '1px solid #f2f2f2',
        borderRadius: "8px",
        minHeight: '350px'
      }}
    >
      <Row justify='space-between'>
        <Col>
          <Typography.Title
            level={4}
            style={{
              margin: '0px 0px 16px 0px',
              padding: '0px',
              // background: '#293c68',
              // color: '#FFF',
              // borderRadius: '8px'

            }}
          >
            รายการสินค้าคงคลัง
          </Typography.Title>
        </Col>
        <Col >
          <Row>
            <Col>
              <Typography.Text
                style={{
                  fontSize: '18px',
                  marginRight: '8px'
                }}
              >รวม</Typography.Text>
            </Col>
            <Col>

              <Statistic value={productQuantity} valueStyle={{ fontSize: 18, textAlign: 'right', marginRight: '8px' }} />
            </Col>
            <Col>
              <Typography.Text
                style={{
                  fontSize: '18px',
                  marginRight: '8px'
                }}
              >ชิ้น</Typography.Text>
            </Col>
            <Col>
              <Typography.Text
                style={{
                  fontSize: '18px',
                  marginRight: '8px'
                }}
              >มูลค่า</Typography.Text>
            </Col>
            <Col>
              <Statistic value={productPrice.toFixed(0)} valueStyle={{ fontSize: 18, textAlign: 'right', marginRight: '8px' }} />
            </Col>
            <Col>
              <Typography.Text
                style={{
                  fontSize: '18px'
                }}
              >บาท</Typography.Text>
            </Col>
          </Row>
        </Col>
      </Row>
      <Table
        size='small'
        rowKey={(record) => record.id}
        columns={columns}
        dataSource={products}
        scroll={{
          x: 1200,
        }}
      />
    </Card>
  )
}

export default DashboardInventory